import { createRouter, createWebHistory } from "vue-router";
import DomainHandler from "../whitelabel/domainHandler";

export const routes = [
  {
    path: "/:companyId?",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "/dashboard/:id/:companyId?",
        name: "DashboardsShow",
        component: () => import("../views/dashboards/DashboardShowPage.vue"),
        meta: { titleKey: "dashboardPage.viewHeading" },
      },
      {
        path: "/services/:service/:companyId?",
        name: "Services",
        component: () => import("../views/Blank.vue"),
      },
      {
        path: "/availability/:service/:companyId?",
        name: "Availability",
        component: () => import("../views/availability/Availability.vue"),
      },
      {
        path: "/backupplan/:modemSysId?/:planSysId?/:companyId?",
        name: "BackupPlan",
        component: () => import("../views/BackupPlan.vue"),
      },
      {
        path: "/modem/:type/:id?/:companyId?",
        name: "Modem",
        component: () => import("../views/Modem.vue"),
      },
      {
        path: "/acu/:id/:companyId?",
        name: "ACU",
        component: () => import("../views/devices/ACU.vue"),
      },
      {
        path: "/ipinterface/:id/:companyId?",
        name: "IPInterface",
        component: () => import("../views/devices/IPInterface.vue"),
      },
      {
        path: "/ipsla/:id/:companyId?",
        name: "IPSLA",
        component: () => import("../views/devices/IPSLA.vue"),
      },
      {
        path: "/router/:id/:companyId?",
        name: "Router",
        component: () => import("../views/devices/Router.vue"),
      },
      {
        path: "/versa/:id/:companyId?",
        name: "Versa",
        component: () => import("../views/devices/Versa.vue"),
      },
      {
        path: "/sdwan/:id/:companyId?",
        name: "SDWAN",
        component: () => import("../views/devices/Versa.vue"),
      },
      {
        path: "/switch/:id/:companyId?",
        name: "Switch",
        component: () => import("../views/devices/Switch.vue"),
      },
      {
        path: "/wanaccelerator/:id/:companyId?",
        name: "WANAccelerator",
        component: () => import("../views/devices/WANAccelerator.vue"),
      },
      {
        path: "/device/:id/:companyId?",
        name: "Device",
        component: () => import("../views/devices/Device.vue"),
      },
    ],
  },
  {
    path: "/oneweb/api/status",
    name: "OneWebApiStatus",
    component: () => import("../views/OneWebApiStatus.vue"),
    meta: { titleKey: "oneweb.apiStatus.pageTitle" },
  },
  {
    path: "/changepassword",
    name: "ChangePassword",
    component: () => import("../views/ChangePassword.vue"),
  },
  {
    path: "/fleet/:companyId?",
    name: "Fleet",
    component: () => import("../views/fleet/Fleet.vue"),
    children: [
      {
        path: "/fleet/performance/:companyId?",
        name: "Performance",
        component: () => import("../views/fleet/Performance.vue"),
      },
      {
        path: "/fleet/starlinkpoolusage/:companyId?",
        name: "StarlinkPoolUsage",
        component: () => import("../views/fleet/StarlinkPoolsUsage.vue"),
      },
      {
        path: "/fleet/starlinkusage/:companyId?",
        name: "StarlinkFleetUsage",
        component: () => import("../views/fleet/StarlinkFleetUsage.vue"),
      },
    ],
  },
  {
    path: "/testgraph",
    name: "Testgraph",
    component: () => import("../views/Testgraph.vue"),
  },
  {
    path: "/reports",
    name: "Reports",
    component: () => import("../views/reports/Reports.vue"),
    children: [
      {
        path: "/reports/servicesoverview/:companyId?",
        name: "ServicesOverview",
        component: () => import("../views/reports/ServicesOverview.vue"),
      },
      {
        path: "/reports/ipslasoverview/:companyId?",
        name: "IPSLAsOverview",
        component: () => import("../views/reports/IPSLAsOverview.vue"),
      },
      {
        path: "/reports/starlink/:companyId?",
        name: "StarlinkReports",
        component: () => import("../views/reports/StarlinkReports.vue"),
        children: [
          {
            path: "/reports/starlink/usage/:companyId?",
            name: "StarlinkUsageReport",
            component: () => import("../views/reports/StarlinkUsage.vue"),
          },
          {
            path: "/reports/starlink/alerts/:companyId?",
            name: "StarlinkAlertsReport",
            component: () => import("../views/reports/StarlinkAlerts.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/support/:companyId?",
    name: "Support",
    component: () => import("../views/tickets/Support.vue"),
    children: [
      {
        path: "/support/cases/:companyId?",
        name: "Cases",
        component: () => import("../views/tickets/Tickets.vue"),
      },
      {
        path: "/support/cases/view/:number/:companyId?",
        name: "Case",
        component: () => import("../views/tickets/Tickets.vue"),
      },
      {
        path: "/support/change-requests/:companyId?",
        name: "ChangeRequests",
        component: () => import("../views/changeRequests/ChangeRequests.vue"),
      },
      {
        path: "/support/change-requests/view/:number/:companyId?",
        name: "ChangeRequest",
        component: () => import("../views/changeRequests/ChangeRequests.vue"),
      },
    ],
  },
  {
    path: "/starlink/:companyId?",
    name: "Starlink",
    component: () => import("../views/starlink/Starlink.vue"),
    children: [
      {
        path: "/starlink/activatekits/:companyId?",
        name: "StarlinkActivateKits",
        component: () => import("../views/starlink/activation/ActivateKits.vue"),
      },
      {
        path: "/starlink/editserviceplan/:companyId?",
        name: "StarlinkEditServicePlan",
        component: () => import("../views/starlink/planadmin/EditServicePlan.vue"),
      },
      {
        path: "/starlink/changelogs/:companyId?",
        name: "StarlinkChangeLogs",
        component: () => import("../views/starlink/planadmin/ChangeLogs.vue"),
      },
      {
        path: "/starlink/alerts/:companyId?",
        name: "StarlinkAlerts",
        component: () => import("../views/starlink/alerts/StarlinkMonitors.vue"),
      },
    ],
  },
  {
    path: "/apiportal/:companyId?",
    name: "ApiPortal",
    component: () => import("../views/apiPortal/ApiPortal.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/admin/Admin.vue"),
    children: [
      {
        path: "/admin/roles/:companyId?",
        name: "AdminRoles",
        component: () => import("../views/admin/roles/Roles.vue"),
      },
      {
        path: "/admin/roles/changelog/:companyId?",
        name: "AdminRoleChangeLogs",
        component: () => import("../views/admin/roles/AdminChangeLogs.vue"),
      },
      {
        path: "/admin/user-roles/:userId",
        name: "UserRoles",
        component: () => import("../views/admin/roles/UserRoles.vue"),
      },
    ],
  },
  //   {
  //   path: "/tickets/:companyId?",
  //   name: "Tickets",
  //   component: () => import("../views/tickets/Tickets.vue"),
  //   children: [
  //     {
  //       path: "/tickets/view/:number/:companyId?",
  //       name: "Ticket",
  //       component: () => import("../views/tickets/Ticket.vue"),
  //     },
  //   ]
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/guestticket",
    name: "GuestTicket",
    component: () => import("../views/GuestTicket.vue"),
  },
  {
    path: "/resetpassword/:uuid",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/token",
    name: "Token",
    component: () => import("../views/Token.vue"),
  },
  {
    path: "/alerts",
    name: "Alerts",
    component: () => import("../views/Alerts.vue"),
  },
  {
    path: "/my-account",
    name: "MyAccount",
    component: () => import("../views/MyAccount.vue"),
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("../views/Faq.vue"),
  },
  {
    path: "/resources",
    name: "Resources",
    component: () => import("../views/ResourcesPageRenderer.vue"),
  },
  {
    path: "/dashboards",
    name: "Dashboards",
    component: () => import("../views/dashboards/DashboardsView.vue"),
    children: [
      {
        path: "/dashboards/:companyId?",
        name: "DashboardsList",
        component: () => import("../views/dashboards/DashboardsListPage.vue"),
      },
      {
        path: "/dashboards/new/:companyId?",
        name: "DashboardsNew",
        component: () => import("../views/dashboards/DashboardFormPage.vue"),
        meta: { titleKey: "dashboardPage.newBtn" },
      },
      {
        path: "/dashboards/:id/edit/:companyId?",
        name: "DashboardsEdit",
        component: () => import("../views/dashboards/DashboardFormPage.vue"),
        meta: { titleKey: "dashboardPage.editHeading" },
      },
    ],
  },

  // {
  //   path: "/change-requests/:companyId?",
  //   name: "ChangeRequests",
  //   component: () => import("../views/changeRequests/ChangeRequests.vue"),
  //   children: [
  //     {
  //       path: "/change-requests/view/:number/:companyId?",
  //       name: "ChangeRequest",
  //       component: () => import("../views/changeRequests/ChangeRequest.vue"),
  //     },
  //   ]
  // },
];
const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior: async function (to) {
    if (to.hash) {
      for (let i = 0; i < 10; i++) {
        const element = document.querySelector(to.hash);
        if (element) {
          return { el: to.hash, behavior: "smooth", top: 84 };
        }
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      console.warn("Element with selector ${to.hash} not found after retries");
    } else {
      return { top: 0 };
    }
  },
});

let arcgisWarmedUp = false;
router.afterEach((to) => {
  if (
    !arcgisWarmedUp &&
    ["Home", "Services"].includes(to.name) &&
    localStorage.getItem("accessToken") &&
    DomainHandler.getHostname() === "default"
  ) {
    arcgisWarmedUp = true;
    // fire immediately: these fetch+evaluate in parallel with the API chain the
    // map waits on, so the work lands before the view mounts, not during it
    import("../components/ArcGisMap.vue");
    import("@arcgis/core/views/SceneView");
    import("@arcgis/core/widgets/Home");
    import("@arcgis/core/widgets/Expand");
    import("@arcgis/core/widgets/Legend");
    import("@arcgis/core/widgets/Popup");
  }
});

export default router;
